import { render, staticRenderFns } from "./ReceiveDevices.vue?vue&type=template&id=71f8f649"
import script from "./ReceiveDevices.vue?vue&type=script&lang=ts"
export * from "./ReceiveDevices.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports